import React from 'react'
import { List, Separator, Skeleton } from '@fs/zion-ui'
import AddDiscussionButton from '../../components/collaborate/AddDiscussionButton'

export function DiscussionsListLoading(): JSX.Element {
  return (
    <List>
      <Skeleton.ListItem hasSecondLine />
      <Skeleton.ListItem hasSecondLine />
      <Skeleton.ListItem hasSecondLine />
    </List>
  )
}

export default function DiscussionsLoading(): JSX.Element {
  return (
    <>
      {/* eslint-disable-next-line test-selectors/button -- NA */}
      <AddDiscussionButton disabled />
      <Separator size="nano" />
      <DiscussionsListLoading />
    </>
  )
}
